import { ValidatorFn, Validators, AbstractControl, FormArray } from '@angular/forms';
import { select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { TranslationService } from '@cemex-core/angular-localization-v7';

import { NumberValidators } from './../../../cemexcomponents/helpers/v1';
import { AbstractPaymentEngine } from './abstract-payment-engine';
import { PaymentEngineConfiguration } from './payment-engine-configuration';
import { Observable, zip } from 'rxjs';
import { PaymentConfiguration } from './../models/payment-configuration';
import { PaymentRequest } from './../models/payment-request';
import { PayerBrokerRequest, PayerBrokerRequestV1 } from './../models/payer-broker-request';
import * as fromPayments from './../store/reducers/index';
import { PayerBrokerResponse, PayerBrokerV3Response } from './../models/payer-broker-response';
import { Router } from '@angular/router';
import { StorageManagerService } from '@app/core/services/storage-manager.service';

export class PaymentEnginePH extends AbstractPaymentEngine {

    constructor(configuration: PaymentEngineConfiguration, t: TranslationService, private router: Router,
                private storageManagerService: StorageManagerService
    ) {
        super(configuration, t);
    }

    getBanks(): any {
        throw new Error('Method not implemented.');
    }

    // FIXME: Refactor the payment-engine so the amount validator can be defined after getting the parameters from the API CX023GO2003-2088

    getAmountValidators(isDebit: boolean, expectedPayment: number): ValidatorFn | ValidatorFn[] {
        // FIXME: The graterThan is hardcoded, it must be taken from countryparameters API CX023GO2003-2088

        return [ Validators.required,
            NumberValidators.isNumeric, NumberValidators.isPositive, NumberValidators.onlyTwoDecimals,
            NumberValidators.greaterThan(10), NumberValidators.lessThan(expectedPayment) ];
    }

    getPaymentConfiguration(): Observable<PaymentConfiguration> {
        return zip(
            super.initPaymentConfiguration(),
            this.bankService.getBankListV2({
                companyCode: this.company.companyCode,
                countryCode: this.customer.countryCode,
                customerCode: this.customer.customerCode
            })
        ).pipe(
            map(([paymentConfiguration, banks]) => {
                paymentConfiguration.paymentMethods.forEach(pm => pm.paymentNetworks = banks);

                paymentConfiguration.paymentMethods.forEach(pm => {
                    pm.paymentNetworks = banks;
                    pm.displayName = pm.description;
                    pm.displayDescription =  this.t.pt('views.regular_payments.transfer_method_description')
                    pm.displayIcon = 'selection-container__icon cmx-icon-module-invoices-payments';
                    pm.checked = pm.code.toLowerCase() === 'transfer' ? true : false;
                });

                return paymentConfiguration;
            })
        );
    }

    createReference(request: PaymentRequest): Observable<any> {
        return this.paymentService.createReferenceV3(request);
    }

    getPayerBroker(request: PayerBrokerRequest, brokerCode: string): Observable<any> {
        let paymentType = '';
        let transactionType = '';
        let transactionDescType = '';
          ///TODO: Obtener de countryParamters
        request.paymentHeader.currencyKey = 'PH';
        this.store.pipe(
                select(fromPayments.isAdvancePayment),
                map(isAdvancePayment => {
                    transactionType = isAdvancePayment ? 'AVP' : 'RGP';
                    transactionDescType = isAdvancePayment ? 'Advance Payment' : 'Regular Payment';
                      if (isAdvancePayment && request.paymentType.paymentTypeCode === 'TR') {
                          paymentType = '113';
                      } else if (!isAdvancePayment && request.paymentType.paymentTypeCode === 'TR') {
                          paymentType = '1';
                      }

                      request.paymentType.paymentTypeCode = paymentType;
                })
            ).subscribe();

        const userProfile = this.storageManagerService.user_profile;
        const refreshToken = this.storageManagerService.refresh_token;
        const request2: PayerBrokerRequestV1 = {
            country: {
                countryCode: request.country.countryCode
            },
            company: {
                companyCode: request.company.companyCode,
                companyDesc: ''
            },
            payment: {
                paymentAmount: request.amount,
                fee: request.paymentHeader.fee,
                subTotal: request.paymentHeader.subTotal,
                reference: {
                    referenceNumber: request.referenceCode
                },
                transaction: {
                    transactionType: transactionType,
                    transactionDesc: transactionDescType
                },
                status: {
                    statusCode: request.paymentHeader.statusTransaction,
                    statusDesc: ''
                },
                method: {
                    methodCode: request.paymentHeader.paymentMethod,
                    methodDesc: ''
                },
                currency: {
                    currencyCode: request.paymentHeader.currencyKey,
                    currencyDesc: ''
                },
                datePayment: request.paymentHeader.datePay,
                timePayment: request.paymentHeader.timePay,
                partialPayment: '',
            },
            customer: {
                customerCode: request.customer.customerCode,
                customerDesc: request.customer.customerDesc
            },
            user: {
                userAccount: userProfile.userAccount,
                userName: userProfile.fullName
            }
            //   urlRedirect: window.location.href.substring( 0, document.location.href.lastIndexOf( '/' ))
            //       + '/return?token=' + refreshToken + '&amp;c=' + request.country.countryCode
            //       + '&amp;b=BDO01' + '&amp;r=' + request.referenceCode
          };
          return this.paymentService.getPayerBrokerV3( request2, 'BDO');
  }

    callToNetworking(totalToPay: string, referenceCode: string, payerInformation: PayerBrokerResponse): void {

      const parameters = payerInformation
            .formParams
            .map(x => {
                return {
                    [x.key]: atob(x.value)
                }
            })
            .reduce((result, item) => {
                const key = Object.keys(item)[0];
                result[key] = item[key];
                return result;
            }, {});

            const action = parameters.endpoint;

        const payerBrokerObject: PayerBrokerV3Response = {...parameters as unknown as PayerBrokerV3Response};
        //payerBrokerObject.txtMerURL =  `${window['API_HOST']}${payerBrokerObject.txtMerURL}`;
        payerBrokerObject.txtMerURL = payerBrokerObject.txtMerURL;
        delete payerBrokerObject.txtProdCode;
        delete payerBrokerObject.endpoint;

        this.createFormRequestNetwork(action, 'GET', '_blank', payerBrokerObject);
    }

    isExternalCompany(companyCode: string): boolean {
        return false;
    }

    saveExternalOrderRelation(): any {
        throw new Error('Method not implemented.');
    }

    getHeaderPayerInformation(request: any, payerInformationResponse: any, storeDataInfo: any): any {
        const paymentHeader = request.header;
        const response = payerInformationResponse;
        let psePaymentType = paymentHeader.paymentMethod.toLowerCase() === 'TR' ? '113'
                        : paymentHeader.paymentMethod.toLowerCase() === 'credit' ? '1113' : '';
        const payerObj = {
            countryCode: paymentHeader.countryCompany,
            customerCode: paymentHeader.customerNo1,
            referenceCode: response.idTransaction,
            amount: paymentHeader.amountLocalCurrency,
            companyCode: paymentHeader.companyCode,
            paymentType: psePaymentType,
            customerDesc: paymentHeader.client,
            userAccount: storeDataInfo.UserAccount,
        urlRedirect: window.location.href.substring(0, document.location.href.lastIndexOf( '/' ))
            + '/return?token=' + storeDataInfo.Token + '&amp;c=' + paymentHeader.countryCompany + '&amp;b=BDO01'  + '&amp;r=' + response.idTransaction,
            externalOrder: storeDataInfo.ExternalOrder
        };

        return payerObj;
    }

}
